import { t } from "i18next";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BsXLg } from "react-icons/bs";
import { StyledModalBtn } from "../BetSlip/BetslipStyle";

//page scroll stop
export const useDisableBodyScroll = (open) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [open]);
};

const CustomModal = ({ modalClose, modalShow, modalMsg, modalHeight }) => {
  useDisableBodyScroll(modalShow);

  const { t } = useTranslation("General");

  return (
    <React.Fragment>
      <div className={modalShow ? "d-block" : "d-none"}>
        <div className="d-flex justify-content-center position-fixed start-0 end-0 w-100 modal-container" style={{ height: `${modalHeight}px` }} >
          <div className="card border border-1 rounded-3 position-absolute text-dark bet-modal w-50 betslip-popup">
            <div className="card-header pe-0 pt-0">
              <button onClick={modalClose} className="float-end border border-0"><BsXLg /></button>
              <h4 className="text-center pt-3">V-League</h4>
            </div>

            <div className="card-body p-3 text-center fs-5">{t(`${modalMsg}`)}</div>

            <div className="card-footer d-flex justify-content-center p-1">
              <StyledModalBtn
                onClick={modalClose}
                className="btn btn-secondary text-white fw-bold px-4"
              >
                {t("OK")}
              </StyledModalBtn>
            </div>

          </div>


        </div>
      </div>
    </React.Fragment>
  );
};
export default CustomModal;
